<template>
    <article class="block--employee block--light  block--listed">
        <div class="inner">
            <span class="screen-reader-text">(Open post)</span>
            <a :href="postdata.slug" class="image--right"  v-lazy-container="{ selector: 'img' }" v-html="fixPhotoForLazyLoad(postdata.photo_html)"></a>
            <div class="person-desc">
                <a class="name-link" :href="postdata.slug">
                    <h3 class="person-title text--600">{{ postdata.first_name }}</br>{{ postdata.lastname }}</h3>
                    <div v-if="(postdata.position && postdata.position[0]  )" class="person-position" v-html=" postdata.position[0].name"></div>
                </a>
                <div class="person-meta text--300">
                    <ul v-if="postdata.emails" class="person-phones">
                        <li v-if="email['email'].indexOf('@bahr') >= 0" v-for="email in postdata.emails" :key="email['email']">
                            <a :href="'mailto:'+email['email']" >{{email['email']}}</a>
                        </li>
                    </ul>
                    <ul v-if="postdata.phone_numbers" class="person-phones">
                        <li v-if="number['phone_number'].length > 8" v-for="number in postdata.phone_numbers" :key="number['phone_number']" >
                            <a :href="'tel:'+number['phone_number']" >{{number['phone_number']}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </article>
</template>


<script>
export default {
    name: 'postblock',
    props: ['postdata'],
    data(){
        return {
            some : [],
        };
    },
    methods: {
        fixPhotoForLazyLoad(photoHtml){
            return photoHtml.replace('src', 'data-src')
        }
/*         loadTaxes(){
            let self = this;
            this.postdata[this.tax_name].forEach(function(element) {
                self.loadTaxonomyById(element).then(x => { 
                    //self.taxonomies[element] = x ;
                    //self.$forceUpdate();
                    self.$set(self.taxonomies, element, x);
                });
            });
        }, */
    },
	mounted: function(){
        //this.loadTaxes();
       // this.lazyLoadImages();
        //this.post_cats = this.getTaxName(4);

	},
	updated: function(){
		//this.refreshImages();
	}
    
}
</script>



// WEBPACK FOOTER //
// src/js/vue/components/singleEmploye.vue?2f274d60